// extracted by mini-css-extract-plugin
export default {"major_med_payments_controls":"MajorMedPayments_major_med_payments_controls__QZcnW","container":"MajorMedPayments_container__vAFEZ"};